import { Card } from "@omni/ui/components/Card/card";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatISO } from "@/utils/date";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    balance: number;
    expirationDate: string;
};

const GiftCardBalance = ({ balance, expirationDate }: Props) => {
    const { t } = useGranite();

    return (
        <Card>
            <Card.Body>
                <Card.Title tag="h2">
                    {t("general.giftCardRequestBalance.title")}
                </Card.Title>
                <p>
                    <span>{t("general.giftCardRequestBalance.balance")}: </span>
                    <span
                        className={cn("tw:font-bold tw:text-danger tw:text-lg")}
                    >
                        {formatPrice(balance)}
                    </span>
                </p>
                <p>
                    <span>
                        {t("general.giftCardRequestBalance.expirationDate")}:{" "}
                    </span>
                    <span
                        className={cn("tw:font-bold tw:text-danger tw:text-lg")}
                    >
                        {formatISO(expirationDate)}
                    </span>
                </p>
            </Card.Body>
        </Card>
    );
};

export default GiftCardBalance;
